import script from "./AdditionalPeople.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalPeople.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__